import * as ParameterConfigurations from '../services/parameterConfigurations'
import { parameterConfigurationErrorAction, parameterConfigurationLoadingAction, parameterConfigurationUpdateAction } from './parameterConfigurationsSlice'

export const fetchParameterConfiguration = (
  siteID: string,
  assetID: string
) => async (dispatch: any) => {
  dispatch(parameterConfigurationLoadingAction())
  await ParameterConfigurations.fetchParameterConfigurations(
    siteID,
    assetID,
    (response, httpStatus) => {
      dispatch(parameterConfigurationUpdateAction(response))
    },
    (errorMessage, httpStatus) => {
      dispatch(parameterConfigurationErrorAction(errorMessage))
    }
  )
}
